var map = {
	"./bronze.png": 144,
	"./challenger.png": 145,
	"./diamond.png": 369,
	"./gold.png": 370,
	"./grandmaster.png": 371,
	"./iron.png": 372,
	"./master.png": 373,
	"./platinum.png": 374,
	"./silver.png": 375,
	"./unranked.png": 376
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 449;


//////////////////
// WEBPACK FOOTER
// ./src/assets/tier-icons ^\.\/.*$
// module id = 449
// module chunks = 1